'use client';
import Heading from "@/components/molecules/Heading";
import Image from "@/components/atoms/image";
import React from "react";
import { TwoInfoTextBlockProps } from "@/page-builder/fragments/TwoInfoTextBlock/types";
import BupiLinkButton from "@/components/atoms/linkButton";
import BupiLink from "@/components/atoms/link";
import WrapperBlueStyle from "@/components/atoms/wrapper-blue-style";
import { convertLexicalWithInternalLinks } from "@/lib/lexical";

interface ModuleMapProps {
  data: TwoInfoTextBlockProps;
}

export const ModuleMap: React.FC<ModuleMapProps> = ({ data }) => {
  const leftInfo = data.info[0]
  const rightInfo = data.info[1]
  
  const mapImageUrl = data.image?.url || "/mapa.svg";
  const mapImageAlt = data.image?.alt || "Mapa de Portugal com os municípios destacados";

  const Content = () => (
    <div className="container mx-auto grid md:grid-cols-2 gap-3">
      <section 
        className="z-50"
      >
        <div>
          <Heading title={leftInfo.title} />
          <div
            dangerouslySetInnerHTML={{
              __html: convertLexicalWithInternalLinks(
                leftInfo.description as any
              ),
            }}
            className="text-m-regular text-neutral-900 py-8 prose prose-ul:my-0 marker:text-neutral-900"
          />
        </div>
        <div className="flex justify-start items-center">
          {leftInfo?.style === 'solid' ? (
           <BupiLinkButton
              className="w-full md:w-auto"
              label={leftInfo?.label}
              link={leftInfo?.url}
              target={leftInfo?.target || "_self"} 
              hasIcon
              leadingIcon="agora-line-arrow-right-circle"
            />
          ) : (
            <BupiLink
              label={leftInfo?.label}
              url={leftInfo?.url}
              target={leftInfo?.target || "_self"}
              hasIcon
              
            />
          )
        }
        </div>
      </section>
      
      <div className="hidden md:block" aria-hidden="true"></div>

      <div 
        className="md:col-span-2 relative md:-mt-128 xl:!-mt-256 my-32 md:my-0" 
        aria-label={mapImageAlt}
      >
        <Image 
          src={mapImageUrl} 
          alt={""}
          width={1200}
          height={800}
          className="w-full"
          sizes="(max-width: 768px) 100vw, 1200px"
          priority
        />
      </div>
      
      <div className="hidden md:block" aria-hidden="true"></div>
      
      <section className="mt-16 md:-mt-128 z-50">
        <div>
          <Heading title={rightInfo.title} />
          <div
            dangerouslySetInnerHTML={{
              __html: convertLexicalWithInternalLinks(
                rightInfo.description as any
              ),
            }}
            className="text-m-regular text-neutral-900 py-8 prose prose-ul:my-0 marker:text-neutral-900"
          />
        </div>
         <div className="flex justify-start  items-center">
           {rightInfo?.style === 'solid' ? (
           <BupiLinkButton
              className="w-full md:w-auto"
              label={rightInfo?.label}
              link={rightInfo?.url}
              target={rightInfo?.target || "_self"} 
              hasIcon
              leadingIcon="agora-line-arrow-right-circle"
            />
          ) : (
            <BupiLink
              label={rightInfo?.label}
              url={rightInfo?.url}
              target={rightInfo?.target || "_self"}
              hasIcon
              className="py-16"
            />
          )
        }
        </div>
      </section>
    </div>
  );

  return data?.background === "green" ? (
      <WrapperBlueStyle noSpace>
        <Content />
      </WrapperBlueStyle>
    ) : (
      <Content />
    );
};

export default function TwoInfoTextBlock({ data }: { data: TwoInfoTextBlockProps }) {
  return (
    <div role="region" aria-label="Informações e mapa">
      <ModuleMap data={data} />
    </div>
  );
}
